<template>
  <div class="chooseComboView">
    <el-dialog
      :visible.sync="chooseComboDialogVisible"
      :close-on-click-modal="false"
      width="970px"
      class="chooseComboDialog"
    >
      <div slot="title" class="chooseComboView-title" v-html="title"></div>
      <div class="center">
        <div class="chooseCombo dfcjsb" style="margin-bottom:30px">
          <div
            class="item"
            v-for="(item, index) in comboList"
            :key="item.id"
            :class="index == activeIndex ? 'curr' : ''"
            @click="activeIndex = index"
          >
            <div class="color99 font14">
              <p class="pb-3">
                <span class="money c-title">{{ item.price }}</span
                >元
              </p>
              <p class="onsal">
                {{ item.originalPrice }}<span class="color99 font14">{{ item.priceUnit }}</span>
              </p>
            </div>
            <div style="text-align:left">
              <p class="font18 pb-7">{{ item.quantity + item.quantityUnit }}</p>
              <p class="color99 mt-5 font12 ">
                <span>折后价</span><span style="color:#ff3938"> {{ item.perPrice + item.perPriceUnit }}</span>
              </p>
            </div>
            <div v-if="item.giftQuantity > 0" class="item-badge">
              {{ "再送" + item.giftQuantity + item.quantityUnit }}
            </div>
            <!-- <div class="item-badge"></div> -->
          </div>
        </div>
        <div class="mt20 color999 dfc">
          <!-- 更高规格套餐,联系商务定制(177-5912-6083) -->
          <span style="color:#8c5733">更高规格套餐，请联系客服定制</span>
          <el-popover placement="bottom" trigger="hover">
            <div style="text-align:center;width:90px;margin:0 auto">
              <p class="font14 fontWB mb12">微信客服</p>
              <img src="../../../assets/wxkf.jpg" style="width:80px;height:80px" alt="" />
              <p class="font12 mt10" style="color:#999">微信扫一扫</p>
            </div>
            <a slot="reference" class="header-baidu" href="javascript:void(0);" rel="nofollow">
              <span class="iconfont iconweixin" style="margin-left:8px;font-size:20px;color:#62b900"></span> </a
          ></el-popover>
        </div>
        <div class="mt20 color999" v-if="typeText == 0">
          使用：套餐数将用于产品中的图片违禁词检测（1个产品消耗1个），仅支持1688平台产品
        </div>
        <div v-else class="mt20 color999">
          套餐数将用于图片违禁词检测/图片方正字体检测(1张图片消耗1张)，仅支持图片及图片地址
        </div>
        <div class="button-content mt40 tc mb20">
          <el-button type="primary" @click="rightNowBuy">立即充值</el-button>
        </div>
      </div>
    </el-dialog>
    <pay ref="pay" @close="chooseComboDialogVisible = false" @OnSuccess="buySuccess"></pay>
  </div>
</template>

<script>
import pay from "./pay";
export default {
  components: { pay },
  data() {
    return {
      chooseComboDialogVisible: false,
      title: "",
      activeIndex: 0,
      comboList: [],
      orderInfo: "",
      chooseComboType: 0,
      fwCheckType: 0, // 产品类型
      page: "", //从那个页面唤起的组件
      typeText: "",
      Package: [],
    };
  },
  mounted() {},
  computed: {},
  methods: {
    async show(fwCheckType, fwPackageTimeType) {
      let PackageList = await this.getFwPackage(fwCheckType, fwPackageTimeType); // 获取套餐数据
      let title = this.setTitle(fwCheckType); // 获取标题
      this.title = title;
      this.comboList = PackageList.reverse();
      this.fwCheckType = fwCheckType;
      this.activeIndex = 0;
      this.typeText = fwCheckType;
      this.chooseComboDialogVisible = true;
    },
    setTitle(fwCheckType) {
      let title = "";
      switch (fwCheckType) {
        case 0:
          title = '<p class="chooseComboView-title" style="text-align: center;">感恩回馈，限时特惠</p>';

          // title = '<p class="chooseComboView-title" style="text-align: center;">9月套餐充值低至0.1元/个</p>';
          break;
        case 1:
          // title = '<p class="chooseComboView-title"  style="text-align: center;">9月套餐充值低至0.04元/张</p>';
          title = '<p class="chooseComboView-title" style="text-align: center;">感恩回馈，限时特惠</p>';

          break;
      }
      return title;
    },
    //  获取套餐 fwCheckType产品类型，fwPackageTimeType套餐类型
    getFwPackage(fwCheckType, fwPackageTimeType) {
      var that = this;
      return new Promise((resolve) => {
        var PackageList = [];
        this.$ajax.post("/kuaio/api/ForbiddenWord/Package/GetFwPackage", {}).then((res) => {
          if (res.code == 200) {
            let { result } = res;
            result.forEach((element) => {
              // 判断 产品类型
              if (element.fwCheckType == fwCheckType) {
                // 判断 套餐类型
                if (element.fwPackageTimeType == fwPackageTimeType) {
                  PackageList.push(element);
                }
              }
            });
            resolve(PackageList);
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    rightNowBuy(arg) {
      let chooseCombo = this.comboList[this.activeIndex];
      let Parma = {
        fwCheckType: chooseCombo.fwCheckType,
        code: chooseCombo.code,
        cost: chooseCombo.price,
      };
      ///  这里 buryingpoint 埋点
      if (this.page && this.page == "buy") this.$utils.buryingpoint("快哦登录--购买--立即支付");
      if (this.fwCheckType == 0 && !this.page) this.$utils.buryingpoint("快哦登录--1688产品套餐--立即支付");
      if (this.fwCheckType == 1 && !this.page) this.$utils.buryingpoint("快哦登录--图片套餐--立即支付");
      this.$refs.pay.GetPackageQrcode(Parma);
    },
    showOrder() {
      this.$refs.order.orderDialogVisible = true;
    },
    //购买成功
    buySuccess(e) {
      this.$emit("buySuccess", e);
    },
  },
};
</script>

<style lang="scss" scoped>
.onsal {
  text-decoration: line-through;
}

.chooseComboView {
  line-height: 1;

  .chooseComboDialog {
    .center {
      .chooseCombo {
        .item {
          display: flex;
          align-items: center;
          justify-content: space-around;
          border: 1px solid #ddd;
          width: 208px;
          height: 110px;
          border-radius: 4px;
          color: #000;
          overflow: hidden;
          position: relative;
          cursor: pointer;
          // &::before {
          //   position: absolute;
          //   top: 50%;
          //   left: 42%;
          //   transform: translateY(-50%);
          //   content: "";
          //   width: 1px;
          //   height: 40px;
          //   background: #ddd;
          // }
          .imgClass {
            position: absolute;
            top: 0;
            left: 0;
          }
          div {
            width: 50%;
            text-align: center;
            position: relative;
          }
          div:nth-child(1)::after {
            content: "";
            position: absolute;
            right: 12px;
            height: 40px;
            width: 1px;
            top: 6px;
            background: #ddd;
          }
          .money {
            font-size: 30px;
            color: red;
          }
          .item-badge {
            width: auto;
            position: absolute;
            top: 0px;
            right: 0px;
            font-size: 12px;
            display: inline-block;
            padding: 3px 8px;
            background: red;
            border-radius: 0 0 0 10px;
            color: #fff;
          }
        }
        .curr {
          border: 1px solid rgb(255, 192, 92);
          position: relative;
          background: #fffdf9;
          box-shadow: 0 1px 2px rgba(255, 192, 92, 0.4);
        }
        .curr::after {
          content: "";
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: 31px;
          height: 31px;
          background: url("../../../assets/buy/actice_version_1.9.2.png");
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.chooseComboView {
  .chooseComboDialog {
    /deep/ .el-dialog {
      border-radius: 4px 4px 4px 4px;
      .el-dialog__header {
        padding: 20px;
        background: linear-gradient(to right, #ffedcc, #facd87);
        font-size: 24px;
        font-weight: 700;
        border-radius: 4px 4px 0 0;
        color: #8c5733;
        .el-dialog__close {
          color: white;
        }
      }
    }
    /deep/ .el-dialog__body {
      padding: 30px 40px 20px 40px;
      .button-content {
        & > .el-button {
          width: 140px;
          height: 45px;
          padding: 12px 20px;
          font-size: 16px;
          border: none;
          background: linear-gradient(to bottom, #ff5447, #ff3a39);
        }
      }
    }
  }
}
</style>
